'use client';

import styles from './organization-hosted-events.module.scss';
import { EventCard } from '@goodneighbor/ui';
import useEventsQuery from '@/hooks/api/events/useEventsQuery';
import { EventsResponse } from '@goodneighbor/api/schemas/events/index';
import { useState } from 'react';
import EventSlideOut from '@/components/EventSlideOut';
import { EventWithOrganization } from '@/services/webApi';
import { parseForEventCardProps } from '@/services/event';

type HostedEventsSectionProps = {
  organizationId: string;
  organizationName: string;
};

export function HostedEventsSection({
  organizationId,
  organizationName
}: HostedEventsSectionProps) {
  const [selectedEvent, setSelectedEvent] =
    useState<EventWithOrganization | null>(null);
  const { data, isLoading, isError } = useEventsQuery({
    organization: organizationId,
    perPage: 5,
    showUnapproved: true
  });

  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <section className={styles.container}>
        <h2 className={styles.title}>Hosted Events</h2>
        <p className={styles.message}>Failed to load events.</p>
      </section>
    );
  }

  const events = (data as EventsResponse)?.data?.events || [];

  if (events.length === 0) {
    return (
      <section className={styles.container}>
        <h2 className={styles.title}>Hosted Events</h2>
        <p className={styles.message}>No upcoming events.</p>
      </section>
    );
  }

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Hosted Events</h2>
      <div className={styles.grid}>
        {events.map((event) => (
          <EventCard
            key={event.id}
            {...parseForEventCardProps(event, organizationName)}
            onClick={() => setSelectedEvent(event as EventWithOrganization)}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>
      <EventSlideOut
        isOpen={!!selectedEvent}
        onOpenChange={() => setSelectedEvent(null)}
        event={selectedEvent}
      />
    </section>
  );
}
